import { SET_CLIENT_DETAILS } from './client.actions';

const initialState = {
  details: {},
};

export const clientReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CLIENT_DETAILS:
      return {
        ...state,
        details: payload,
      };
    default:
      return state;
  }
};
